export default __webpack_public_path__ + "static/media/quiz-walkthrough-bg.cfce8b69.svg";